import type { AuthFailureCode } from './auth-client.ts';

export function authErrorMessageId(
  error: AuthFailureCode | null,
): 'web.auth.invalid' | 'web.auth.expired' | 'web.auth.error' | null {
  if (!error || error === 'conflict' || error === 'merge-conflict') return null;
  return error === 'expired' || error === 'invalid'
    ? `web.auth.${error}`
    : 'web.auth.error';
}
